export const getCoworkingFloorLabel = (floorFrom: number, floorTo: number): string | null => {
  if (!floorFrom && !floorTo) {
    return null;
  }

  if (!floorTo) {
    return `${floorFrom}`;
  }

  if (floorFrom === floorTo) {
    return floorFrom.toString();
  }

  return `с\u00A0${floorFrom}\u00A0по\u00A0${floorTo}`;
};
